import { getJSON } from '../utils/json';
import { getCurrencyFormatFromLookup, setCurrencyFormatCache, getDefaultCurrencyFormat } from './currencyFormatLookup';

export default ({ staticBaseURL }) => ({
    async getCurrencyFormat(iso, currency) {
        // First, try to get from lookup table
        const cachedFormat = getCurrencyFormatFromLookup(iso, currency);
        if (cachedFormat) {
            return cachedFormat;
        }

        // If not in lookup table, fetch from API
        try {
            const format = await getJSON(`${staticBaseURL}/currency/format/?iso=${iso}&currency=${currency}`);

            // Cache the result for future use
            setCurrencyFormatCache(iso, currency, format);

            return format;
        } catch (error) {
            console.warn(`Failed to fetch currency format for ${iso}-${currency}, using default`, error);
            // Return a default format if API fails
            return getDefaultCurrencyFormat(currency);
        }
    },
});
